import React from 'react';
import { Link } from 'react-router-dom';
import { C, IMG, WHATSAPP_URL, EMAIL } from '../theme';

const LINKS = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About Us' },
  { to: '/services', label: 'Our Services' },
  { to: '/contact', label: 'Contact' },
];

export default function Footer() {
  const heading = { fontSize: 13, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.06em', color: C.orangeSoft, margin: '0 0 18px' };
  const link = { textAlign: 'left', background: 'none', border: 'none', fontFamily: 'inherit', fontSize: 15.5, color: '#B9CBC4', cursor: 'pointer', padding: 0 };

  return (
    <footer style={{ background: C.tealDark, color: '#B9CBC4' }}>
      <div data-cn-footer-grid style={{ maxWidth: 1200, margin: '0 auto', padding: '64px 24px 32px', display: 'grid', gridTemplateColumns: '1.4fr 1fr 1.3fr', gap: 44 }}>
        <div>
          <img src={`${IMG}/logo-white.png`} alt="CarelyNest" style={{ height: 40, width: 'auto', marginBottom: 18 }} />
          <p style={{ fontSize: 15.5, lineHeight: 1.66, color: '#9FB4AC', margin: '0 0 20px', maxWidth: 320 }}>
            Trusted caregivers for the people you love most — verified, trained, and accountable.
          </p>
          <a
            className="cn-wa-pill"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'inline-flex', alignItems: 'center', gap: 9, background: C.waGreenDark, color: '#fff', fontWeight: 800, fontSize: 14.5, padding: '11px 18px', borderRadius: 999 }}
          >
            ✆ Chat on WhatsApp
          </a>
        </div>

        <div>
          <h4 style={heading}>Explore</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {LINKS.map((l) => (
              <Link key={l.to} to={l.to} className="cn-footer-link" style={link}>{l.label}</Link>
            ))}
          </div>
        </div>

        <div>
          <h4 style={heading}>Get in touch</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12, fontSize: 15.5, lineHeight: 1.5 }}>
            <a className="cn-footer-link" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" style={{ color: '#B9CBC4' }}>WhatsApp · +234 812 577 7959</a>
            <a className="cn-footer-link" href={`mailto:${EMAIL}`} style={{ color: '#B9CBC4' }}>{EMAIL}</a>
            <span style={{ color: '#9FB4AC' }}>2nd Floor, 42 Montgomery Road, Yaba, Lagos</span>
            <span style={{ color: '#9FB4AC' }}>Mon–Fri 8am–6pm · Sat 9am–3pm · Sun closed</span>
          </div>
        </div>
      </div>

      <div style={{ borderTop: '1px solid rgba(255,255,255,.1)' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '20px 24px', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10, fontSize: 13.5, color: '#7E948B' }}>
          <span>© {new Date().getFullYear()} CarelyNest. All rights reserved.</span>
          <span>Where compassion feels like home.</span>
        </div>
      </div>
    </footer>
  );
}
